import React from 'react'
import { Spinner } from "react-bootstrap";

function SpinnerComponent() {
    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop:'50px'
    }}>
    <Spinner />
    </div >
  )
}

export default SpinnerComponent